import MuiCard from '@material-ui/core/Card';
import MuiCardContent from '@material-ui/core/CardContent';
import MuiCardHeader from '@material-ui/core/CardHeader';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { CONTAINER, TEXT } from '../Colors';
import { BODY, HEADING_03 } from '../Fonts';

const StyledCard = withStyles({
    root: {
        font: BODY,
        color: TEXT,
        backgroundColor: CONTAINER,
        display: 'flex',
        flexDirection: 'column',
        '&>.MuiCardHeader-root': {
            padding: '8px 12px',
            paddingBottom: 0,
            '&>.MuiCardHeader-title': {
                font: HEADING_03,
            },
            '&>.MuiCardHeader-action': {
                '& .MuiIconButton-root': {
                    color: TEXT,
                },
                '& .MuiToolbar-root': {
                    marginBottom: '-8px',
                    minHeight: '0px',
                    padding: '0px',
                },
            },
        },
        '&>.MuiCardContent-root': {
            padding: '12px',
            flex: '1'
        },
        '&>div:nth-child(2)': {
            paddingTop: '4px',
            flex: '1'
        }
    },
})(MuiCard);

const useStyles = makeStyles({
    fullWidth: {
        width: '100%',
    },
    fullHeight: {
        height: '100%',
    },
    hidden: {
        display: 'none',
    }
});


interface ContainerProps {
    headerTitle?: React.ReactNode,
    headerActions?: React.ReactNode,
    fullWidth?: boolean,
    fullHeight?: boolean,
    hidden?: boolean,
}

export const Container: React.FunctionComponent<ContainerProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const className = `${props.fullWidth ? classes.fullWidth : ''} ${props.fullHeight ? classes.fullHeight : ''} ${props.hidden ? classes.hidden : ''} ${stylingClassName}`

    return (
        <StyledCard className={className}>
            {(props.headerTitle || props.headerActions) && <MuiCardHeader title={props.headerTitle} action={props.headerActions} />}
            <div className={'scroll'}>
                <MuiCardContent>
                    {props.children}
                </MuiCardContent>
            </div>
        </StyledCard>
    );


}
